import { cn } from 'lib/helpers/utility';

/**
 * @param {import('./lib/propTypes').ProgressProps} props
 */

const ProgressBar = ({
  progress,
  className,
  progressColor = 'bg-primary-500',
  stripeColor = 'bg-[color:var(--color-secondary-200,#E9EAEB)]',
  isShine = false,
  ariaValueNow,
  ariaLabel = 'Progress'
}) => {
  // Only expose progressbar semantics when a real value is supplied; decorative
  // usages (no ariaValueNow) render exactly as before.
  const hasAriaValue = Number.isFinite(ariaValueNow);
  const ariaProps = hasAriaValue
    ? {
        role: 'progressbar',
        'aria-label': ariaLabel,
        'aria-valuenow': ariaValueNow,
        'aria-valuemin': 0,
        'aria-valuemax': 100
      }
    : {};

  return (
    <div
      className={cn('relative h-[6px] w-full rounded-[6px]', stripeColor, className)}
      {...ariaProps}>
      <div
        className={cn(
          'absolute left-0 top-0 h-full rounded-[6px] transition-all duration-700 ease-out',
          isShine &&
            progress > 0 &&
            'before:absolute before:inset-0 before:z-10 before:rounded-[6px] before:bg-[linear-gradient(to_right,transparent_85%,rgba(255,255,255,0.6)_100%)] before:content-[""]',
          progressColor
        )}
        style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default ProgressBar;
